/**
 * Complete world countries list for @ollaid/native-sso
 * Default: Sénégal (+221, SN)
 */

export interface Country {
  code: string;      // ISO 2-letter (e.g. "SN")
  name: string;      // Display name
  dialCode: string;  // Phone prefix (e.g. "+221")
  flag: string;      // Emoji flag
  digits: number;    // Expected phone number length (without prefix)
}

// West Africa prioritized at top, then rest of Africa, Europe, Americas, Asia, Oceania
export const COUNTRIES: Country[] = [
  // ── Afrique de l'Ouest (prioritaires) ──
  { code: "SN", name: "Sénégal", dialCode: "+221", flag: "🇸🇳", digits: 9 },
  { code: "CI", name: "Côte d'Ivoire", dialCode: "+225", flag: "🇨🇮", digits: 10 },
  { code: "ML", name: "Mali", dialCode: "+223", flag: "🇲🇱", digits: 8 },
  { code: "BF", name: "Burkina Faso", dialCode: "+226", flag: "🇧🇫", digits: 8 },
  { code: "GN", name: "Guinée", dialCode: "+224", flag: "🇬🇳", digits: 9 },
  { code: "TG", name: "Togo", dialCode: "+228", flag: "🇹🇬", digits: 8 },
  { code: "BJ", name: "Bénin", dialCode: "+229", flag: "🇧🇯", digits: 8 },
  { code: "NE", name: "Niger", dialCode: "+227", flag: "🇳🇪", digits: 8 },
  { code: "MR", name: "Mauritanie", dialCode: "+222", flag: "🇲🇷", digits: 8 },
  { code: "GW", name: "Guinée-Bissau", dialCode: "+245", flag: "🇬🇼", digits: 7 },
  { code: "GM", name: "Gambie", dialCode: "+220", flag: "🇬🇲", digits: 7 },
  { code: "CV", name: "Cap-Vert", dialCode: "+238", flag: "🇨🇻", digits: 7 },
  { code: "SL", name: "Sierra Leone", dialCode: "+232", flag: "🇸🇱", digits: 8 },
  { code: "LR", name: "Liberia", dialCode: "+231", flag: "🇱🇷", digits: 7 },
  { code: "GH", name: "Ghana", dialCode: "+233", flag: "🇬🇭", digits: 9 },
  { code: "NG", name: "Nigeria", dialCode: "+234", flag: "🇳🇬", digits: 10 },

  // ── Afrique Centrale ──
  { code: "CM", name: "Cameroun", dialCode: "+237", flag: "🇨🇲", digits: 9 },
  { code: "GA", name: "Gabon", dialCode: "+241", flag: "🇬🇦", digits: 7 },
  { code: "CG", name: "Congo", dialCode: "+242", flag: "🇨🇬", digits: 9 },
  { code: "CD", name: "RD Congo", dialCode: "+243", flag: "🇨🇩", digits: 9 },
  { code: "TD", name: "Tchad", dialCode: "+235", flag: "🇹🇩", digits: 8 },
  { code: "CF", name: "Centrafrique", dialCode: "+236", flag: "🇨🇫", digits: 8 },
  { code: "GQ", name: "Guinée équatoriale", dialCode: "+240", flag: "🇬🇶", digits: 9 },
  { code: "ST", name: "São Tomé-et-Príncipe", dialCode: "+239", flag: "🇸🇹", digits: 7 },
  { code: "BI", name: "Burundi", dialCode: "+257", flag: "🇧🇮", digits: 8 },
  { code: "RW", name: "Rwanda", dialCode: "+250", flag: "🇷🇼", digits: 9 },

  // ── Afrique de l'Est ──
  { code: "KE", name: "Kenya", dialCode: "+254", flag: "🇰🇪", digits: 9 },
  { code: "TZ", name: "Tanzanie", dialCode: "+255", flag: "🇹🇿", digits: 9 },
  { code: "UG", name: "Ouganda", dialCode: "+256", flag: "🇺🇬", digits: 9 },
  { code: "ET", name: "Éthiopie", dialCode: "+251", flag: "🇪🇹", digits: 9 },
  { code: "SO", name: "Somalie", dialCode: "+252", flag: "🇸🇴", digits: 8 },
  { code: "DJ", name: "Djibouti", dialCode: "+253", flag: "🇩🇯", digits: 8 },
  { code: "ER", name: "Érythrée", dialCode: "+291", flag: "🇪🇷", digits: 7 },
  { code: "SS", name: "Soudan du Sud", dialCode: "+211", flag: "🇸🇸", digits: 9 },
  { code: "MG", name: "Madagascar", dialCode: "+261", flag: "🇲🇬", digits: 9 },
  { code: "MU", name: "Maurice", dialCode: "+230", flag: "🇲🇺", digits: 8 },
  { code: "SC", name: "Seychelles", dialCode: "+248", flag: "🇸🇨", digits: 7 },
  { code: "KM", name: "Comores", dialCode: "+269", flag: "🇰🇲", digits: 7 },

  // ── Afrique Australe ──
  { code: "ZA", name: "Afrique du Sud", dialCode: "+27", flag: "🇿🇦", digits: 9 },
  { code: "MZ", name: "Mozambique", dialCode: "+258", flag: "🇲🇿", digits: 9 },
  { code: "ZW", name: "Zimbabwe", dialCode: "+263", flag: "🇿🇼", digits: 9 },
  { code: "ZM", name: "Zambie", dialCode: "+260", flag: "🇿🇲", digits: 9 },
  { code: "MW", name: "Malawi", dialCode: "+265", flag: "🇲🇼", digits: 9 },
  { code: "BW", name: "Botswana", dialCode: "+267", flag: "🇧🇼", digits: 8 },
  { code: "NA", name: "Namibie", dialCode: "+264", flag: "🇳🇦", digits: 9 },
  { code: "AO", name: "Angola", dialCode: "+244", flag: "🇦🇴", digits: 9 },
  { code: "SZ", name: "Eswatini", dialCode: "+268", flag: "🇸🇿", digits: 8 },
  { code: "LS", name: "Lesotho", dialCode: "+266", flag: "🇱🇸", digits: 8 },

  // ── Afrique du Nord ──
  { code: "MA", name: "Maroc", dialCode: "+212", flag: "🇲🇦", digits: 9 },
  { code: "DZ", name: "Algérie", dialCode: "+213", flag: "🇩🇿", digits: 9 },
  { code: "TN", name: "Tunisie", dialCode: "+216", flag: "🇹🇳", digits: 8 },
  { code: "LY", name: "Libye", dialCode: "+218", flag: "🇱🇾", digits: 9 },
  { code: "EG", name: "Égypte", dialCode: "+20", flag: "🇪🇬", digits: 10 },
  { code: "SD", name: "Soudan", dialCode: "+249", flag: "🇸🇩", digits: 9 },

  // ── Europe ──
  { code: "FR", name: "France", dialCode: "+33", flag: "🇫🇷", digits: 9 },
  { code: "BE", name: "Belgique", dialCode: "+32", flag: "🇧🇪", digits: 9 },
  { code: "CH", name: "Suisse", dialCode: "+41", flag: "🇨🇭", digits: 9 },
  { code: "DE", name: "Allemagne", dialCode: "+49", flag: "🇩🇪", digits: 10 },
  { code: "GB", name: "Royaume-Uni", dialCode: "+44", flag: "🇬🇧", digits: 10 },
  { code: "ES", name: "Espagne", dialCode: "+34", flag: "🇪🇸", digits: 9 },
  { code: "IT", name: "Italie", dialCode: "+39", flag: "🇮🇹", digits: 10 },
  { code: "PT", name: "Portugal", dialCode: "+351", flag: "🇵🇹", digits: 9 },
  { code: "NL", name: "Pays-Bas", dialCode: "+31", flag: "🇳🇱", digits: 9 },
  { code: "SE", name: "Suède", dialCode: "+46", flag: "🇸🇪", digits: 9 },
  { code: "NO", name: "Norvège", dialCode: "+47", flag: "🇳🇴", digits: 8 },
  { code: "DK", name: "Danemark", dialCode: "+45", flag: "🇩🇰", digits: 8 },
  { code: "FI", name: "Finlande", dialCode: "+358", flag: "🇫🇮", digits: 10 },
  { code: "PL", name: "Pologne", dialCode: "+48", flag: "🇵🇱", digits: 9 },
  { code: "AT", name: "Autriche", dialCode: "+43", flag: "🇦🇹", digits: 10 },
  { code: "IE", name: "Irlande", dialCode: "+353", flag: "🇮🇪", digits: 9 },
  { code: "GR", name: "Grèce", dialCode: "+30", flag: "🇬🇷", digits: 10 },
  { code: "CZ", name: "Tchéquie", dialCode: "+420", flag: "🇨🇿", digits: 9 },
  { code: "RO", name: "Roumanie", dialCode: "+40", flag: "🇷🇴", digits: 9 },
  { code: "HU", name: "Hongrie", dialCode: "+36", flag: "🇭🇺", digits: 9 },
  { code: "BG", name: "Bulgarie", dialCode: "+359", flag: "🇧🇬", digits: 9 },
  { code: "HR", name: "Croatie", dialCode: "+385", flag: "🇭🇷", digits: 9 },
  { code: "SK", name: "Slovaquie", dialCode: "+421", flag: "🇸🇰", digits: 9 },
  { code: "SI", name: "Slovénie", dialCode: "+386", flag: "🇸🇮", digits: 8 },
  { code: "RS", name: "Serbie", dialCode: "+381", flag: "🇷🇸", digits: 9 },
  { code: "UA", name: "Ukraine", dialCode: "+380", flag: "🇺🇦", digits: 9 },
  { code: "RU", name: "Russie", dialCode: "+7", flag: "🇷🇺", digits: 10 },
  { code: "TR", name: "Turquie", dialCode: "+90", flag: "🇹🇷", digits: 10 },
  { code: "LU", name: "Luxembourg", dialCode: "+352", flag: "🇱🇺", digits: 9 },
  { code: "MC", name: "Monaco", dialCode: "+377", flag: "🇲🇨", digits: 8 },
  { code: "IS", name: "Islande", dialCode: "+354", flag: "🇮🇸", digits: 7 },
  { code: "AL", name: "Albanie", dialCode: "+355", flag: "🇦🇱", digits: 9 },
  { code: "ME", name: "Monténégro", dialCode: "+382", flag: "🇲🇪", digits: 8 },
  { code: "MK", name: "Macédoine du Nord", dialCode: "+389", flag: "🇲🇰", digits: 8 },
  { code: "BA", name: "Bosnie-Herzégovine", dialCode: "+387", flag: "🇧🇦", digits: 8 },
  { code: "LT", name: "Lituanie", dialCode: "+370", flag: "🇱🇹", digits: 8 },
  { code: "LV", name: "Lettonie", dialCode: "+371", flag: "🇱🇻", digits: 8 },
  { code: "EE", name: "Estonie", dialCode: "+372", flag: "🇪🇪", digits: 8 },
  { code: "MT", name: "Malte", dialCode: "+356", flag: "🇲🇹", digits: 8 },
  { code: "CY", name: "Chypre", dialCode: "+357", flag: "🇨🇾", digits: 8 },
  { code: "MD", name: "Moldavie", dialCode: "+373", flag: "🇲🇩", digits: 8 },
  { code: "GE", name: "Géorgie", dialCode: "+995", flag: "🇬🇪", digits: 9 },
  { code: "AM", name: "Arménie", dialCode: "+374", flag: "🇦🇲", digits: 8 },
  { code: "AZ", name: "Azerbaïdjan", dialCode: "+994", flag: "🇦🇿", digits: 9 },
  { code: "BY", name: "Biélorussie", dialCode: "+375", flag: "🇧🇾", digits: 9 },

  // ── Amérique du Nord ──
  { code: "US", name: "États-Unis", dialCode: "+1", flag: "🇺🇸", digits: 10 },
  { code: "CA", name: "Canada", dialCode: "+1", flag: "🇨🇦", digits: 10 },
  { code: "MX", name: "Mexique", dialCode: "+52", flag: "🇲🇽", digits: 10 },

  // ── Amérique Centrale & Caraïbes ──
  { code: "HT", name: "Haïti", dialCode: "+509", flag: "🇭🇹", digits: 8 },
  { code: "DO", name: "République dominicaine", dialCode: "+1809", flag: "🇩🇴", digits: 10 },
  { code: "CU", name: "Cuba", dialCode: "+53", flag: "🇨🇺", digits: 8 },
  { code: "JM", name: "Jamaïque", dialCode: "+1876", flag: "🇯🇲", digits: 7 },
  { code: "GT", name: "Guatemala", dialCode: "+502", flag: "🇬🇹", digits: 8 },
  { code: "HN", name: "Honduras", dialCode: "+504", flag: "🇭🇳", digits: 8 },
  { code: "SV", name: "El Salvador", dialCode: "+503", flag: "🇸🇻", digits: 8 },
  { code: "NI", name: "Nicaragua", dialCode: "+505", flag: "🇳🇮", digits: 8 },
  { code: "CR", name: "Costa Rica", dialCode: "+506", flag: "🇨🇷", digits: 8 },
  { code: "PA", name: "Panama", dialCode: "+507", flag: "🇵🇦", digits: 8 },
  { code: "TT", name: "Trinité-et-Tobago", dialCode: "+1868", flag: "🇹🇹", digits: 7 },

  // ── Amérique du Sud ──
  { code: "BR", name: "Brésil", dialCode: "+55", flag: "🇧🇷", digits: 11 },
  { code: "AR", name: "Argentine", dialCode: "+54", flag: "🇦🇷", digits: 10 },
  { code: "CO", name: "Colombie", dialCode: "+57", flag: "🇨🇴", digits: 10 },
  { code: "CL", name: "Chili", dialCode: "+56", flag: "🇨🇱", digits: 9 },
  { code: "PE", name: "Pérou", dialCode: "+51", flag: "🇵🇪", digits: 9 },
  { code: "VE", name: "Venezuela", dialCode: "+58", flag: "🇻🇪", digits: 10 },
  { code: "EC", name: "Équateur", dialCode: "+593", flag: "🇪🇨", digits: 9 },
  { code: "BO", name: "Bolivie", dialCode: "+591", flag: "🇧🇴", digits: 8 },
  { code: "PY", name: "Paraguay", dialCode: "+595", flag: "🇵🇾", digits: 9 },
  { code: "UY", name: "Uruguay", dialCode: "+598", flag: "🇺🇾", digits: 8 },
  { code: "GY", name: "Guyana", dialCode: "+592", flag: "🇬🇾", digits: 7 },
  { code: "SR", name: "Suriname", dialCode: "+597", flag: "🇸🇷", digits: 7 },

  // ── Moyen-Orient ──
  { code: "AE", name: "Émirats arabes unis", dialCode: "+971", flag: "🇦🇪", digits: 9 },
  { code: "SA", name: "Arabie saoudite", dialCode: "+966", flag: "🇸🇦", digits: 9 },
  { code: "QA", name: "Qatar", dialCode: "+974", flag: "🇶🇦", digits: 8 },
  { code: "KW", name: "Koweït", dialCode: "+965", flag: "🇰🇼", digits: 8 },
  { code: "BH", name: "Bahreïn", dialCode: "+973", flag: "🇧🇭", digits: 8 },
  { code: "OM", name: "Oman", dialCode: "+968", flag: "🇴🇲", digits: 8 },
  { code: "JO", name: "Jordanie", dialCode: "+962", flag: "🇯🇴", digits: 9 },
  { code: "LB", name: "Liban", dialCode: "+961", flag: "🇱🇧", digits: 8 },
  { code: "IQ", name: "Irak", dialCode: "+964", flag: "🇮🇶", digits: 10 },
  { code: "IR", name: "Iran", dialCode: "+98", flag: "🇮🇷", digits: 10 },
  { code: "IL", name: "Israël", dialCode: "+972", flag: "🇮🇱", digits: 9 },
  { code: "PS", name: "Palestine", dialCode: "+970", flag: "🇵🇸", digits: 9 },
  { code: "YE", name: "Yémen", dialCode: "+967", flag: "🇾🇪", digits: 9 },
  { code: "SY", name: "Syrie", dialCode: "+963", flag: "🇸🇾", digits: 9 },

  // ── Asie ──
  { code: "CN", name: "Chine", dialCode: "+86", flag: "🇨🇳", digits: 11 },
  { code: "JP", name: "Japon", dialCode: "+81", flag: "🇯🇵", digits: 10 },
  { code: "KR", name: "Corée du Sud", dialCode: "+82", flag: "🇰🇷", digits: 10 },
  { code: "IN", name: "Inde", dialCode: "+91", flag: "🇮🇳", digits: 10 },
  { code: "PK", name: "Pakistan", dialCode: "+92", flag: "🇵🇰", digits: 10 },
  { code: "BD", name: "Bangladesh", dialCode: "+880", flag: "🇧🇩", digits: 10 },
  { code: "ID", name: "Indonésie", dialCode: "+62", flag: "🇮🇩", digits: 10 },
  { code: "MY", name: "Malaisie", dialCode: "+60", flag: "🇲🇾", digits: 10 },
  { code: "PH", name: "Philippines", dialCode: "+63", flag: "🇵🇭", digits: 10 },
  { code: "TH", name: "Thaïlande", dialCode: "+66", flag: "🇹🇭", digits: 9 },
  { code: "VN", name: "Vietnam", dialCode: "+84", flag: "🇻🇳", digits: 9 },
  { code: "SG", name: "Singapour", dialCode: "+65", flag: "🇸🇬", digits: 8 },
  { code: "HK", name: "Hong Kong", dialCode: "+852", flag: "🇭🇰", digits: 8 },
  { code: "TW", name: "Taïwan", dialCode: "+886", flag: "🇹🇼", digits: 9 },
  { code: "MM", name: "Myanmar", dialCode: "+95", flag: "🇲🇲", digits: 9 },
  { code: "KH", name: "Cambodge", dialCode: "+855", flag: "🇰🇭", digits: 9 },
  { code: "LA", name: "Laos", dialCode: "+856", flag: "🇱🇦", digits: 10 },
  { code: "NP", name: "Népal", dialCode: "+977", flag: "🇳🇵", digits: 10 },
  { code: "LK", name: "Sri Lanka", dialCode: "+94", flag: "🇱🇰", digits: 9 },
  { code: "AF", name: "Afghanistan", dialCode: "+93", flag: "🇦🇫", digits: 9 },
  { code: "UZ", name: "Ouzbékistan", dialCode: "+998", flag: "🇺🇿", digits: 9 },
  { code: "KZ", name: "Kazakhstan", dialCode: "+7", flag: "🇰🇿", digits: 10 },
  { code: "MN", name: "Mongolie", dialCode: "+976", flag: "🇲🇳", digits: 8 },

  // ── Océanie ──
  { code: "AU", name: "Australie", dialCode: "+61", flag: "🇦🇺", digits: 9 },
  { code: "NZ", name: "Nouvelle-Zélande", dialCode: "+64", flag: "🇳🇿", digits: 9 },
  { code: "FJ", name: "Fidji", dialCode: "+679", flag: "🇫🇯", digits: 7 },
  { code: "PG", name: "Papouasie-Nouvelle-Guinée", dialCode: "+675", flag: "🇵🇬", digits: 8 },
];

// ── Defaults ──
export const DEFAULT_COUNTRY_CODE = "SN";
export const DEFAULT_DIAL_CODE = "+221";

// ── Sorted by ISO code (alphabetical) ──
export const COUNTRIES_SORTED_BY_CODE: Country[] = [...COUNTRIES].sort((a, b) => a.code.localeCompare(b.code));

// ── Helpers ──
export const getCountryByCode = (code: string): Country | undefined =>
  COUNTRIES.find(c => c.code.toLowerCase() === code.toLowerCase());

export const getCountryByDialCode = (dialCode: string): Country | undefined =>
  COUNTRIES.find(c => c.dialCode === dialCode);

export const getDefaultCountry = (): Country =>
  COUNTRIES.find(c => c.code === DEFAULT_COUNTRY_CODE)!;

export const searchCountries = (query: string): Country[] => {
  const q = query.toLowerCase().trim();
  if (!q) return COUNTRIES;
  return COUNTRIES.filter(c =>
    c.name.toLowerCase().includes(q) ||
    c.dialCode.includes(q) ||
    c.code.toLowerCase().includes(q)
  );
};
